const TIPO_REPORTE_606_VALUE = "606";
const TIPO_REPORTE_606_LABEL = "Reporte 606";

const TIPO_PERIODO_MENSUAL = "M";
const TIPO_PERIODO_MENSUAL_LABEL = "Mensual";
const TIPO_PERIODO_ANUAL = "A";
const TIPO_PERIODO_ANUAL_LABEL = "Anual";

const MES_ENERO = 1;
const MES_FEBRERO = 2;
const MES_MARZO = 3;
const MES_ABRIL = 4;
const MES_MAYO = 5;
const MES_JUNIO = 6;
const MES_JULIO = 7;
const MES_AGOSTO = 8;
const MES_SEPTIEMBRE = 9;
const MES_OCTUBRE = 10;
const MES_NOVIEMBRE = 11;
const MES_DICIEMBRE = 12;
const MES_ENERO_LABEL  = "Enero";
const MES_FEBRERO_LABEL  = "Febrero";
const MES_MARZO_LABEL  = "Marzo";
const MES_ABRIL_LABEL  = "Abril";
const MES_MAYO_LABEL  = "Mayo";
const MES_JUNIO_LABEL  = "Junio";
const MES_JULIO_LABEL  = "Julio";
const MES_AGOSTO_LABEL  = "Agosto";
const MES_SEPTIEMBRE_LABEL = "Septiembre";
const MES_OCTUBRE_LABEL  = "Octubre";
const MES_NOVIEMBRE_LABEL = "Noviembre";
const MES_DICIEMBRE_LABEL = "Diciembre";

export class Reporte606 {
  static TIPO_REPORTE = TIPO_REPORTE_606_VALUE;
  static TIPO_REPORTE_LABEL = TIPO_REPORTE_606_LABEL;

  static TIPO_PERIODO_MENSUAL = TIPO_PERIODO_MENSUAL;
  static TIPO_PERIODO_ANUAL = TIPO_PERIODO_ANUAL;

  static get TIPO_PERIODO_LIST() {
    return [
      { value: TIPO_PERIODO_MENSUAL, label: TIPO_PERIODO_MENSUAL_LABEL },
      { value: TIPO_PERIODO_ANUAL, label: TIPO_PERIODO_ANUAL_LABEL },
    ];
  }

  static get MESES_LIST() {
    return [
      { value: MES_ENERO, label: MES_ENERO_LABEL },
      { value: MES_FEBRERO, label: MES_FEBRERO_LABEL },
      { value: MES_MARZO, label: MES_MARZO_LABEL },
      { value: MES_ABRIL, label: MES_ABRIL_LABEL },
      { value: MES_MAYO, label: MES_MAYO_LABEL },
      { value: MES_JUNIO, label: MES_JUNIO_LABEL },
      { value: MES_JULIO, label: MES_JULIO_LABEL },
      { value: MES_AGOSTO, label: MES_AGOSTO_LABEL },
      { value: MES_SEPTIEMBRE, label: MES_SEPTIEMBRE_LABEL },
      { value: MES_OCTUBRE, label: MES_OCTUBRE_LABEL },
      { value: MES_NOVIEMBRE, label: MES_NOVIEMBRE_LABEL },
      { value: MES_DICIEMBRE, label: MES_DICIEMBRE_LABEL },
    ];
  }

  static getAnosList() {
    const now = new Date().getFullYear();
    const out = [];
    for (let y = 2007; y <= now + 1; y++) {
      out.push({ value: y, label: String(y) });
    }
    return out.sort((a, b) => b.value - a.value);
  }

  static getDefaultMesAno() {
    const now = new Date();
    const isJanuary = now.getMonth() === 0;
    return {
      mes: isJanuary ? 12 : now.getMonth(),
      ano: isJanuary ? now.getFullYear() - 1 : now.getFullYear(),
    };
  }
}
